module.exports = __webpack_public_path__ + "static/media/logo.4cb2b540.png";